module.exports = __webpack_public_path__ + "img/main_bg_02.1ee637d0.jpg";